export default "__VITE_ASSET__CFf5bkI7__"